import { yup } from '@jbc-year-end-adj/common/yup';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { fileSchemaFormat } from '@jbc-year-end-adj/2024/utils/formatter';
import { Handicap, HandicapClassification } from './query';

export type Schema = {
  classification: HandicapClassification;
  detail?: string;
  image: File | FileType | null;
};

export const buildSchema = (imageRequired: boolean) => {
  return yup.object({
    classification: yup.mixed<HandicapClassification>().required(),
    detail: yup
      .string()
      .nullable()
      .label('障害者詳細情報'),
    image: imageRequired
      ? yup
          .mixed<File | FileType>()
          .required()
          .fileSize()
          .label('障害者手帳画像')
      : yup
          .mixed<File | FileType>()
          .nullable()
          .fileSize()
          .label('障害者手帳画像')
  });
};

export const buildDefaultValues = (handicap?: Handicap) => {
  return {
    classification: handicap?.classification || 'none',
    detail: handicap?.detail,
    image: fileSchemaFormat(handicap?.image)
  };
};
